import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { useParams } from "react-router-dom";

import { apiRequest } from "../../api/apiRequest";

import Loading from "../Loading";
import Navbar from "../Navbar";
import SideMenu from "../SideMenu";

import { InternaDaNorma } from "./InternaDaNorma";

export function InternalScreen() {
    const { t } = useTranslation();

    const { path, id } = useParams();

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [infoApresentacao, setInfoApresentacao] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            let requestPath = path;

            if (path === "norma") {
                requestPath = "dashboard/norma";
            }

            try {
                const response = await apiRequest(
                    "GET",
                    `/${requestPath}/${id}`,
                );

                if (path === "apresentacao") {
                    setData(response.data.newsletter.conteudo);
                    setInfoApresentacao(response.data.newsletter);
                } else if (path === "norma") {
                    setData(response.data.norma);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        window.scrollTo(0, 0);
    }, [id, path]);

    if (loading) {
        return <Loading />;
    }

    if (error) return <p className="mx-3"> {t("interna.errorMessage")}</p>;

    return (
        <div id="wrapper" style={{ backgroundColor: "#043A5E" }}>
            <SideMenu />

            <div
                id="page-wrapper"
                className="pb-5"
                style={{ backgroundColor: "#FCFCFD" }}
            >
                <Navbar />

                <div
                    className="bg-white shadow-sm d-flex flex-column justify-content-between"
                    style={{ borderRadius: "1rem" }}
                >
                    {path === "apresentacao" && data && (
                        <div>
                            <div style={{ textAlign: 'center'}}>
                                <span style={{ fontSize: "20px" }}>Este Report foi visualizado <span style={ { fontWeight: "bold", color: "#043A5E" }}>{infoApresentacao.views + infoApresentacao.views_email}</span> vez(es)</span>
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: data }} />
                        </div>
                    )}
                    {path === "norma" && data && <InternaDaNorma data={data} />}
                </div>
            </div>
        </div>
    );
}
